import React, { Component } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Chapter from "./Chapter";

const Wrapper = styled.div`;
  display: flex;
  flex-direction: column;
  background: ${props => props.theme.colors.primaryDark};
`;

class Chapters extends Component {
  static propTypes = {
    book: PropTypes.object,
    onMainMenuToggle: PropTypes.func.isRequired
  }
  render() {
    const { book, onMainMenuToggle } = this.props;

    return (
      <Wrapper className="wrapper">
        {book &&
          book.chapters.map(chapter => (
            <Chapter key={chapter.id} chapter={chapter} onMainMenuToggle={onMainMenuToggle}/>
          ))}
      </Wrapper>
    );
  }
}

const mapStateToProps = state => ({
  book: state.book
});

export default connect(mapStateToProps)(Chapters);



// WEBPACK FOOTER //
// ./src/menu/Chapters.js